import { type ReactElement, type ReactNode, useState, useEffect, ChangeEvent } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "src/app/store";
import Button from "src/components/Button"
import searchImage from "../../../../assests/Icons/search.svg"
import { getDealers, dealersReset, deleteDealer } from "../../hooks/dealers";
import { dealerReset } from "../../hooks/dealer";
import { DealerType } from "../../types/DealerType";
import DealerModal from "./DealerModal";
import DealerList from "./DealerList";
import { disconnect } from "process";
import Spinner from "src/components/Spinner";
import { endUserReset } from "src/features/dealers/hooks/endUser";
import { endUsersReset } from "src/features/dealers/hooks/endUsers";
import DeleteModal from "src/components/DeleteModal";

export interface AdminMainProps {
        children?: ReactNode
}

const initialDealer = {
        Id: 0,
        DealerId: "",
        Name: "",
        Address: "",
        Enabled: false,
        EmailId: "",
        PhoneNumber: "",
        Notes: "",
        PrimaryContactEmail: "",
        PrimaryContactPhone: "",
        CreatedAt: "",
        ModifiedAt: "",
        Addresses: {
                Address1: "",
                Address2: "",
                City: "",
                State: "",
                Country: "US",
                PostalCode: "",
                AddressType: ""
        }
}

export default function AdminMain(props: AdminMainProps): ReactElement {
        const [isModalOpen, setModalOpen] = useState(false);
        const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
        const [modalTitle, setModalTitle] = useState("");
        const [deleteModalTitle, setDeleteModalTitle] = useState("");
        const [selectedDealer, setDealer] = useState<DealerType | undefined>(initialDealer);
        const dispatch = useDispatch<AppDispatch>();
        const [localDealers, setLocalDealers] = useState<DealerType[]>([]);
        const { dealers, dealersLoading } = useSelector((state: RootState) => state.dealers);

        const navigate = useNavigate();

        const AddDealer = () => {
                setModalOpen(true);
                setModalTitle("Add Dealer");
                setDealer(initialDealer);
        }

        const EditDealer = (event: React.MouseEvent<HTMLDivElement>) => {
                const id = event.currentTarget.id;
                const dealer = dealers.find(e => e.Id === Number(id));
                setModalOpen(true);
                setModalTitle("Edit Dealer");
                setDealer(dealer);
        }

        const DeleteDealerClicked = (event: React.MouseEvent<HTMLDivElement>) => {
                const id = event.currentTarget.id;
                const dealer = dealers.find(e => e.Id === Number(id));
                setDealer(dealer);
                setDeleteModalTitle("Delete Dealer");
                setDeleteModalOpen(true);
        }

        const DeleteDealer = async (doDelete: boolean) => {
                if (doDelete) {
                        await dispatch(deleteDealer(selectedDealer));
                }
                setDeleteModalTitle("");
                setDeleteModalOpen(false);
        }

        const dealerClicked = (event: React.MouseEvent<HTMLDivElement>) => {
                const id = event.currentTarget.id;
                dispatch(dealerReset());
                dispatch(endUsersReset());
                dispatch(endUserReset());
                navigate('/endUsers', { state: { dealerID: id } });
        }

        const Filter = () => {

        }

        const searchChange = (event: ChangeEvent<HTMLInputElement>) => {
                let dealerListFiltered: DealerType[] = localDealers.filter(dealer => dealer.Name.toLowerCase().startsWith(event.target.value.toLowerCase()));
                if (dealerListFiltered.length > 0) {
                        setLocalDealers(dealerListFiltered);
                }
                if (event.target.value.length == 0) {
                        setLocalDealers(dealers);
                }
        }

        useEffect(() => {
                setLocalDealers(dealers);
        }, [])

        return <>
                {!dealersLoading ?
                        (
                                <div className="grid grid-rows-[1fr_19fr] h-[inherit] gap-2">
                                        <div className="place-content-between flex flex-auto gap-4">
                                                <div className="flex basis-full bg-white">
                                                        <img className="p-2" src={searchImage} alt="" />
                                                        <input className="w-full hover:border-black" id="search" type="text" onChange={searchChange} />
                                                </div>
                                                <Button className="basis-1/2" size="sm" type="button" buttonStyle="primary" handleClick={Filter}>Filter</Button>
                                                <Button className="basis-1/2" size="sm" type="button" buttonStyle="primary" handleClick={AddDealer}>Add Dealer</Button>
                                        </div>
                                        <DealerList dealerList={localDealers} dealerClick={dealerClicked} editDealerClick={EditDealer} deleteDealerClick={DeleteDealerClicked} />

                                        {isModalOpen ?
                                                <DealerModal title={modalTitle} selectedDealer={selectedDealer} isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
                                                :
                                                <></>
                                        }
                                        {isDeleteModalOpen ?
                                                <DeleteModal title={deleteModalTitle} delete={DeleteDealer} isOpen={isDeleteModalOpen} onClose={() => setDeleteModalOpen(false)} >Do you want to delete Dealer: {selectedDealer?.Name} ?</DeleteModal>
                                                :
                                                <></>
                                        }
                                </div>
                        ) : <Spinner title="Loading" />
                }
        </>
}
